import { HabitsData } from '../types/habits.types'
import { contentfulClient } from './graphqlClient'

const HABITS_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					habitos {
						beneficioCollection(limit: 10) {
							items {
								idReto
								tituloGeneral
								filtros
								comunidad
								beneficioCollection(limit: 10) {
									items {
										idReto
										duracionDelReto
										textoBoton
										link
										linkSecundario
										descripcionDelReto {
											json
										}
										formatoReto
										tituloGeneral
										descripcionGeneral
										tituloCard
										descripcionCard
										imagen {
											url
										}
										premium
										destacado
										filtros
										comunidad
										isVisible
										beneficioCollection(limit: 50) {
											items {
												idReto
												duracionDelReto
												textoBoton
												link
												linkSecundario
												descripcionDelReto {
													json
												}
												formatoReto
												tituloGeneral
												descripcionGeneral
												tituloCard
												descripcionCard
												imagen {
													url
												}
												premium
												destacado
												filtros
												comunidad
												isVisible
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const habitsApi = {
	async getHabits(): Promise<HabitsData> {
		try {
			const data = await contentfulClient.request<HabitsData>(HABITS_QUERY)
			return data
		} catch (error) {
			console.error('❌ Error fetching habits data:', error)
			throw error
		}
	}
}

export { HABITS_QUERY }
